module.exports = __webpack_public_path__ + "img/press.63f469e3.svg";